import { styled } from "@mui/material";

export const LayoutBasicPageContent = styled("div")({
  display: "flex",
  flexDirection: "column",
  width: "100%",
});
